export default function FidimaBrand({ compact = false }) {
    return (
        <div
            className={"fidima-brand" + (compact ? " is-compact" : "")}
            role="img"
            aria-label="فیدیما"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="146 2 72 60"
                aria-hidden="true"
                focusable="false"
            >
                <path d="M153 28C156.5 14.5 168.5 5 183.5 5c14.8 0 27.2 9.5 30.7 23.2a7 7 0 0 1-13.6 3.4c-1.9-7.4-8.7-12.6-17.1-12.6-8.2 0-15 5-17 12.3l5.2 6.2h-12.5c-4.2 0-7.3-4.8-6.2-9.5Z" />
                <path d="M215 36c-3.5 13.5-15.5 23-30.5 23-14.8 0-27.2-9.5-30.7-23.2a7 7 0 0 1 13.6-3.4c1.9 7.4 8.7 12.6 17.1 12.6 8.2 0 15-5 17-12.3l-5.2-6.2h12.5c4.2 0 7.3 4.8 6.2 9.5Z" />
                <path
                    d="m184 22 2.7 7.3L194 32l-7.3 2.7L184 42l-2.7-7.3L174 32l7.3-2.7L184 22Z"
                    opacity=".55"
                />
            </svg>
            <span>فیدیما</span>
        </div>
    );
}
